import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadApplicationHistoryFailed, loadApplicationHistorySuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import {
  BACKEND_URL_V2, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY,
} from '../../../configs';
import { addFilterQuery } from '../../../utils/addFilterQueryWithCondition';

export default function* loadApplicationHistory(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
      sort,
    } = payload;
    let pool = {
      limit,
      page,
      with_properties: 1,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      // pool.filter = addFilterQueryWithCondition(filter);
      pool.filter = addFilterQuery({ ...filter, subject_type: 'application' });
    }
    if (typeof sort === 'string' && sort.length) {
      pool = { ...pool, sort };
    }
    const url = `${BACKEND_URL_V2}/activity-logs/search`;
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadApplicationHistorySuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadApplicationHistoryFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadApplicationHistoryFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
